import { useEffect, useRef, useState } from 'react';
import { useLoadingState } from '../../hooks/useLoader';
import Overlay from '../../ui/Overlay';
import ModalBox from '../../ui/ModalBox';
import ChangeWalletWhite from './ChangeWalletWhite';

function ChangeWalletModal({ close, handleChangeWalletAddress, type, linkedWallet, from }) {
    const modalRef = useRef(null); // Reference for the modal content

    useEffect(() => {
        // Handle click outside the modal
        function handleClickOutside(e) {
            // Check if the click was outside the modal content
            if (modalRef.current && !modalRef.current.contains(e.target)) {
                close(); // Close the modal if clicked outside
            }
        }

        // Add event listener in the capture phase to ensure proper handling
        document.addEventListener('mousedown', handleClickOutside, true);

        return () => {
            // Clean up the event listener on unmount
            document.removeEventListener('mousedown', handleClickOutside, true);
        };
    }, [close]);

    return (
        <Overlay>
            <div
                ref={modalRef} // Attach ref to modal content
                className="absolute rounded-lg left-[50%] p-6    bg-grayBgNormal translate-x-[-50%] translate-y-[-50%] top-[50%]"
                onClick={(e) => e.stopPropagation()} // Stop propagation to avoid closing the modal when clicked inside
            >
                <ChangeWalletWhite
                    close={close}
                    handleChangeWalletAddress={handleChangeWalletAddress}
                    type={type}
                    linkedWallet={linkedWallet}
                    from={from}
                />
            </div>
        </Overlay>
    );
}

export default ChangeWalletModal;
